import { render, staticRenderFns } from "./AndroidSelect.vue?vue&type=template&id=70ad2bbe&scoped=true"
import script from "./AndroidSelect.vue?vue&type=script&lang=js"
export * from "./AndroidSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad2bbe",
  null
  
)

export default component.exports